var breakpoints = {
    breakpoints: { minTablet: '768px', minWidth: '375px', maxWidth: '1024px' },
};
export default breakpoints;
